import { render, staticRenderFns } from "./mpc.vue?vue&type=template&id=64c6d4f4&scoped=true&"
import script from "./mpc.vue?vue&type=script&lang=js&"
export * from "./mpc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6d4f4",
  null
  
)

export default component.exports